/* eslint-env browser */

'use strict';

require('./index.styl');

require('../old_base/index.js');
require('../vendor/moment');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

const jsInitializer = require('../initializers/js_initializer');

jsInitializer
  .addJsFiles(critModules, nonCritModules, pageReadyModules)
  .initIfReady('old_getaways');
